import { render, staticRenderFns } from "./createItemDetail.vue?vue&type=template&id=6753cf2c&"
import script from "./createItemDetail.vue?vue&type=script&lang=ts&"
export * from "./createItemDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createItemDetail.vue"
export default component.exports